



































import { Component, Vue } from "vue-property-decorator";
import SpaceCardComponent from "@/app/admin/components/space/spaceCard.component.vue";
@Component({
  name: "spaces-list-component",
  components: { SpaceCardComponent },
})
export default class SpacesListComponent extends Vue {
  search = "";
  loading = false;
  searchTimeOut = null;
  lastScroll = 0;
  spaceId = 0;
  superSpaceId = 0;
  mounted(): void {
    this.superSpaceId = parseInt(this.$route.params.id);

    this.$store.dispatch("SpaceStore/setSpacesAvailableAction", []);
    this.$store.dispatch("SpaceStore/setLastPageSpacesAction", 2);
    this.$store.dispatch("SpaceStore/setSpacesAvailablePageAction", 1);
    this.searchSpaces();
    this.scroll();
  }
  destroyed(): void {
    this.$store.dispatch("SpaceStore/setLastPageSpacesAction", 2);
    this.$store.dispatch("SpaceStore/setSpacesAvailablePageAction", 1);
    const spacesList = document.getElementById("scroll-content");
    if (spacesList)
      spacesList.removeEventListener("scroll", this.handler, false);
  }
  handler(): void {
    this.searchInScroll();
  }

  get spaces() {
    let spaces = this.$store.getters["SpaceStore/getSpacesAvailable"];
    if (!spaces)
      return spaces;
    return this.$store.getters["SpaceStore/getSpacesAvailable"].filter((a) =>
      this.search !== ""
        ? a.name
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
            .includes(
              this.search
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase()
            )
        : a
    );
  }
  searchSpaces(): void {
    const page = this.$store.getters["SpaceStore/getSpacesAvailablePage"];
    const lastPage = this.$store.getters["SpaceStore/getLastPageSpaces"];
    if (page <= lastPage) {
      this.loading = true;
      this.$store.dispatch("SpaceStore/getSpacePaginateAction", {
        id: this.superSpaceId,
        callback: () => {
          this.loading = false;
        },
        callbackError: (error) => {
          this.loading = false;
        },
      });
    }
  }
  onSearch(): void {
    //this.$store.dispatch("SpaceStore/setSpacesAvailablePageAction", 1);
    const lengthUsers = this.$store.getters[
      "SpaceStore/getSpacesAvailable"
    ].filter((a) =>
      this.search !== ""
        ? a.name
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
            .includes(
              this.search
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase()
            )
        : a
    ).length;

    if (lengthUsers < 5) {
      this.loading = true;
      if (this.searchTimeOut) clearTimeout(this.searchTimeOut);
      this.loading = true;
      this.searchTimeOut = setTimeout(() => {
        this.$store.dispatch("SpaceStore/getSpacePaginateAction", {
          name: this.search,

          callback: () => {
            this.loading = false;
          },
          callbackError: (error) => {
            this.loading = false;
          },
        });
      }, 1000);
    }
  }
  scroll(): void {
    const spacesList = document.getElementById("scroll-content");
    spacesList.addEventListener("scroll", this.handler);
  }
  searchInScroll(): void {
    const spacesList = document.getElementById("scroll-content");
    const a = spacesList.scrollTop;
    const b = spacesList.scrollHeight - spacesList.clientHeight;
    if (
      this.$route.name === "spaces_list" &&
      this.lastScroll < 0.6 &&
      a / b > 0.6
    ) {
      this.searchSpaces();
    }
    this.lastScroll = a / b;
  }
}
